module.exports = "https://coursera_assets.s3.amazonaws.com/images/e0cdebc690ac9cf50f63ed4b1a0d7e54.png";